import { render } from "./TheLoader.vue?vue&type=template&id=497ded68&scoped=true"
const script = {}

import "./TheLoader.vue?vue&type=style&index=0&id=497ded68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-497ded68"

export default script